import { Link } from 'react-router-dom'

function UserOtherPage() {
  return (
    <section>
      <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto lg:py-0">
        <h1 className="flex items-center lg:mt-24 mb-6 text-2xl font-semibold text-gray-900">
          Outros
        </h1>
        <div className="w-full bg-white rounded-lg shadow md:mt-0 sm:max-w-md xl:p-0">
          <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
            <ul className="space-y-4">
              <li>
                <h2 className="text-lg font-semibold text-gray-900">
                  Lei Geral de Proteção de Dados
                </h2>
                <ul className="mt-2 ml-4 space-y-2">
                  <li>
                    <Link className="font-medium text-green-600 hover:underline" to="/user/gdpr/delete">
                      Excluir dados pessoais
                    </Link>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  )
}

export default UserOtherPage
